export default __webpack_public_path__ + "device_indoor_cam.cc43fb5f.png";